import { render, staticRenderFns } from "./HeaderConfirmation.vue?vue&type=template&id=4878eb02&scoped=true"
import script from "./HeaderConfirmation.vue?vue&type=script&lang=js"
export * from "./HeaderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./HeaderConfirmation.vue?vue&type=style&index=0&id=4878eb02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878eb02",
  null
  
)

export default component.exports